import React from 'react';
import Button from '../../shared/components/Form/Button';
import SPARQLEndpointInterface from './SPARQLEnpointInterface';

import './UploadStep.css';

const UploadStep = props => {
   
    return (<div className="uploadDatasetDiv">
         <h3>1. Define a spatial dataset (point geometries)</h3>
         <form onSubmit={props.onUpload}>
         <div>
         <input type="radio" id="endpoint" name="uploadType" value="endpoint" checked={props.df==="endpoint"} onChange={props.onDFChange} /><label htmlFor="endpoint">&nbsp;SPARQL Endpoint</label>
         <input type="radio" id="shapefile" name="uploadType" value="shapefile" checked={props.df==="shapefile"} onChange={props.onDFChange} /><label htmlFor="shapefile">&nbsp;Shapefile</label>
         <input type="radio" id="geojson" name="uploadType" value="geojson" checked={props.df==="geojson"} onChange={props.onDFChange} /><label htmlFor="geojson">&nbsp;GeoJSON</label>
         </div>
         <div className="uploadFormDiv">

             {props.df==="endpoint" && <div className="selectdatasetFormatDiv">
                 <SPARQLEndpointInterface 
                            endpoint={props.endpointValue}
                            endpointTextChangeHandler={props.onEndpointChange}
                            getSpatialClasses={props.getSpatialClasses}
                            spatialClasses={props.spatialClasses}
                            spatialClass={props.spatialClass}
                            onClassChange={props.onSpatialClassChange}
                            setspclButtonVailidity={props.spclButtonValid}
                            />
             </div>}
             
             {props.df==="shapefile" && <div className="selectdatasetFormatDiv">
             <input id="shapefile" type="file" accept=".zip" onChange={props.onChange}/>
             <p><i>* Select a zip file containing shapefile files (.shp,.dbf,.prj,.shx,etc)</i></p>
             </div>}
             
             {props.df==="geojson" && <div className="selectdatasetFormatDiv">
             <input id="geojson" type="file" accept=".json" onChange={props.onChange}/>
             <p><i>* Select a file with .json extention</i></p>
             </div>} 
                    
         </div>
         <div className="uploadButtonsDiv">
            {props.valid===true ?<Button type="submit">Parse</Button>:<Button type="submit" disabled>Parse</Button>}
            </div>
         </form>
       
         </div>);
    
  };
  
  export default UploadStep;